import { Retailer_Network_Tobacco_Program_Sites_Metric_Sort_By, Sort_Order } from '@occc/graphql';

export const LOCATION_RANKING_TABLE_DEFAULT_PAGE_SIZE = 10;
export const LOCATION_RANKING_TABLE_DEFAULT_SORT_FIELD: Retailer_Network_Tobacco_Program_Sites_Metric_Sort_By =
  Retailer_Network_Tobacco_Program_Sites_Metric_Sort_By.Value;
export const LOCATION_RANKING_TABLE_DEFAULT_SORT_DIRECTION: Sort_Order = Sort_Order.Desc;

export const LOCATION_RANKING_TABLE_AFTER_PARAM = 'location-ranking-after';
export const LOCATION_RANKING_TABLE_BEFORE_PARAM = 'location-ranking-before';
export const LOCATION_RANKING_TABLE_SEARCH_PARAM = 'search';
